export default "__VITE_ASSET__c4b5cf5c__"